<template>
  <div :class="{'sys-theme-norm': !sysTheme || sysTheme === 'norm', 'sys-theme-dark': sysTheme === 'dark'}">
    <router-view class="page_view__base">
      <div style="display: none">
        {{notice}}
      </div>
    </router-view>
    <on-key-down></on-key-down>
  </div>
</template>

<script>
import OnKeyDown from './OnKeyDown'

export default {
  name: 'app',
  components: {
    OnKeyDown
  },
  computed: {
    notice: {
      get () {
        return this.$store.getters.notice
      }
    },
    sysTheme: {
      get () {
        return this.$store.getters.sysTheme
      }
    }
  },
  watch: {
    notice () {
      this.$notify({
        title: this.notice.title,
        message: this.notice.message,
        type: this.notice.type
      })
    }
  },
  mounted () {
    this.$store.dispatch('initHtmlFontSize')
  }
}
</script>

<style lang="less">
@import 'styles/global.less';
@import 'styles/value.less';
// @font-face {
//   font-family: "SourceHanSansCN";
//   src: url('/static/SourceHanSansCN-Normal.otf');
// }
.sys-theme-norm {}
.sys-theme-dark {
  .page_view__base {
    background-color: #050a27;
  }
}
.page_view__base {
  // font-family: SourceHanSansCN;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: @color-app-bak;
}
</style>



// WEBPACK FOOTER //
// src/App.vue